import { useCallback, useSyncExternalStore } from "react";

/** Tailwind's `md` breakpoint: from here up, twins sit side by side. */
export const WIDE = "(min-width: 48rem)";

/**
 * Whether a CSS media query matches, kept current as the window resizes (an
 * iPad turned or split). For a layout CSS alone can't draw, such as showing
 * one baby's charts instead of hiding the rest.
 */
export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (onChange: () => void) => {
      const list = window.matchMedia(query);
      list.addEventListener("change", onChange);
      return () => list.removeEventListener("change", onChange);
    },
    [query],
  );
  return useSyncExternalStore(subscribe, () => window.matchMedia(query).matches);
}
